import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WHATSAPP_URL, PHONE_TEL } from "@/lib/courseData";

export const EnrollButtons = ({ id = "hero", size = "h-12" }) => (
  <div className="flex flex-wrap gap-3">
    <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" data-testid={`${id}-whatsapp-btn`}>
      <Button className={`bg-fin-green text-black hover:bg-fin-green/90 rounded-sm ${size} px-6 text-sm font-semibold`}>
        <MessageCircle className="h-4 w-4 mr-2" /> Enroll on WhatsApp
      </Button>
    </a>
    <a href={PHONE_TEL} data-testid={`${id}-call-btn`}>
      <Button variant="outline" className={`border-white/15 bg-transparent text-white hover:bg-white/5 rounded-sm ${size} px-6 text-sm`}>
        <Phone className="h-4 w-4 mr-2" /> Call Now
      </Button>
    </a>
  </div>
);
